import React from 'react'
import cx from 'classnames'

type Props = {
  children: React.ReactChild | React.ReactChild[]
  className?: string
  buttonNode: React.ReactChild
}

const OrdersProgressCard = ({ children, className, buttonNode }: Props) => {
  return (
    <div
      className={cx(
        'bg-white overflow-y-auto p-4 sm:p-8 shadow-lg absolute rounded-2xl bottom-8 left-1/2 -translate-x-1/2 flex flex-col',
        className
      )}
    >
      <div className="flex-1 flex flex-col">
        <div className="flex-grow flex flex-col">{children}</div>
        {buttonNode}
      </div>
    </div>
  )
}

export default OrdersProgressCard
